import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const AuthGuard = () => {
  // Check for a token in localStorage or sessionStorage (session-only).
  const token = localStorage.getItem("token") || sessionStorage.getItem("token");

  // If no token, redirect to login.
  return token ? <Outlet /> : <Navigate to="/" replace />;
};

export default AuthGuard;
